import { Injectable } from '@angular/core';

import { LayoutComponent } from '@features/shopping/layout/layout.component';
import { clearCartCondition } from '@models/functions.model';
import { CartInfo } from '@models/session-details';
import { ActivityManagerService } from '@services/activity/manager/activity-manager.service';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfirmClearCartGuard {
  constructor(private activity_manager_svc: ActivityManagerService) {}

  canDeactivate(component: LayoutComponent): Observable<boolean> {
    if (this.activity_manager_svc.state().isValidCart(CartInfo.cart_data)) {
      this.activity_manager_svc.clearCart();
      return of(false);
    } else if (CartInfo.cart_data && clearCartCondition(CartInfo.cart_data)) {
      // The in-flight navigation already leaves the shop — clear data only,
      // navigating from here would re-trigger this guard in a loop.
      this.activity_manager_svc.clearCartInBackground(false);
      return of(true);
    }

    return of(true);
  }
}
